// extracted by mini-css-extract-plugin
module.exports = {"container":"CookieConsentDescription_container__fwRzU","bodyText":"CookieConsentDescription_bodyText__4q743","linkText":"CookieConsentDescription_linkText__JcF8F"};